<!--Navigation Bar + Page Title -->
<app-navbar>
    <h2>{{'AGRI_CONTACT.TITLE' | translate}}</h2>
</app-navbar>

<!--Contact Information's-->
<div class="contact-info pt-100 pb-100">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center mb-20">
                <h2>{{'AGRI_CONTACT.TITLE2' | translate}}</h2>
                <p [innerHTML]="'AGRI_CONTACT.SUBTITLE_HTML' | translate"></p>
            </div>

            <!--Email-->
            <div class="col-md-4 col-sm-6 col-12 mb-5">
                <div class="row">
                    <!--Icon Box-->
                    <div class="col-2">
                        <div class="icon-box">
                            <i class="icofont-email icon-style"></i>
                            <span class="white-box"></span>
                        </div>
                    </div>
                    <div class="col-8 ml-4">
                        <!--Title-->
                        <h4 class="info-name mb-5">{{'AGRI_CONTACT.EMAIL' | translate}}</h4>
                        <!--Info-->
                        <ul class="list-unstyled">
                            <li>
                                <a class="links" href="mailto:candidat@agribusinessjob.com">{{'LOGIN.CANDIDATE' | translate}}</a>
                            </li>
                            <li>
                                <a class="links" href="mailto:companie@agribusinessjob.com">{{'LOGIN.COMPANY' | translate}}</a>
                            </li>
                            <li>
                                <a class="links" href="mailto:contact@agribusinessjob.com">GDPR</a>
                            </li>
                            <li>
                                <a class="links" href="mailto:marius.ogrezeanu@agribusinessjob.com">{{'AGRI_CONTACT.FOUNDER' | translate}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!--Phone Number-->
            <div class="col-md-4 col-sm-6 col-12 mb-5">
                <div class="row">
                    <!--Icon Box-->
                    <div class="col-2">
                        <div class="icon-box">
                            <i class="icofont-phone icon-style"></i>
                            <span class="white-box"></span>
                        </div>
                    </div>
                    <div class="col-8 ml-4">
                        <!--Title-->
                        <h4 class="info-name mb-5">{{'AGRI_CONTACT.PHONE' | translate}}</h4>
                        <!--Info-->
                        <ul class="list-unstyled">
                            <li>
                                <a class="links" href="tel:0723266100">(+)40723 266 100<br>Marius Ogrezeanu<br>
                                    {{'AGRI_CONTACT.FOUNDER' | translate}}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!--Address-->
            <div class="col-md-4 col-sm-6 col-12 mb-5">
                <div class="row">
                    <!--Icon Box-->
                    <div class="col-2">
                        <div class="icon-box">
                            <i class="icofont-map icon-style"></i>
                            <span class="white-box"></span>
                        </div>
                    </div>
                    <div class="col-8 ml-4">
                        <!--Title-->
                        <h4 class="info-name mb-5">{{'LOGIN.ADDRESS' | translate}}</h4>
                        <!--Info-->
                        <ul class="list-unstyled">
                            <li>
                                {{'LOGIN.COMPANY' | translate}}: AGRIBUSINESSJOB SRL<br>
                                Date administrative:<br> Cod Fiscal: RO 13659420, Nr. Registrul Comerțului
                                J/17/27/2001<br>
                                Europa - Romania - Oraș Galați - Strada Constantin Brâncoveanu nr. 2

                            </li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<!--Contact From + Map-->
<div class="container-fluid bg-white p-0 overflow-hidden">
    <div class="row py-30">
        <!--Google Map-->
        <div class="col-md-6 col-12">
            <div class="map-area">
                <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d193595.15830869428!2d-74.119763973046!3d40.69766374874431!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2sbd!4v1587549815840!5m2!1sen!2sbd"
                        style="height: 820px"></iframe> -->
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2800.0103841470172!2d28.04066602978261!3d45.42929201225353!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b6defc400a2acf%3A0x51329449b902e4d5!2sStrada%20Constantin%20Br%C3%A2ncoveanu%202%2C%20Gala%C8%9Bi%20800058!5e0!3m2!1sen!2sro!4v1666708027983!5m2!1sen!2sro"
                    height="820" style="border:0;" allowfullscreen="" loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
        </div>
        <!--Contact Form-->
        <div class="col-md-6 col-12">
            <div class="row">
                <div class="col-xl-8 col-12">
                    <div class="contact-form-box pt-10 px-5">
                        <!--Title-->
                        <h2>{{'AGRI_CONTACT.MESSAGE_TITLE' | translate}}</h2>
                        <!--Description-->
                        <p class="mb-10">{{'AGRI_CONTACT.MESSAGE_SUBTITLE' | translate}}</p>

                        <div class="lds-dual-ring"></div>
                        <!--Form Start-->
                        <form [useLoader]="isLoading"
                            (ngSubmit)="contactForm.form.valid && sendContactMessage(contactForm)"
                            #contactForm='ngForm'>
                            <div class="row contact-wrap">

                                <!--Name Input-->
                                <div class="col-12">
                                    <div class="form-group">
                                        <input type="text" class="form-control" name="name" #name='ngModel' id="name"
                                            required ngModel
                                            [ngClass]="{ 'is-invalid': contactForm.submitted && name.invalid }"
                                            placeholder="{{'LOGIN.NAME' | translate}}">
                                        <!--Error Message-->
                                        <div class="error-msg"
                                            *ngIf="!name.valid && (name.touched || contactForm.submitted)">
                                            {{'VALIDATION.REQUIRED' | translate}}
                                        </div>
                                    </div>

                                </div>

                                <!--Email Input-->
                                <div class="col-12">
                                    <div class="form-group">
                                        <input type="email" name="email" id="email" class="form-control" ngModel
                                            required email
                                            [ngClass]="{ 'is-invalid': contactForm.submitted && email.invalid }"
                                            #email="ngModel" placeholder="Email">
                                        <!--Error Message-->
                                        <div class="error-msg"
                                            *ngIf="!email.valid && (email.touched || contactForm.submitted)">
                                            {{'VALIDATION.REQUIRED' | translate}}
                                        </div>
                                    </div>
                                </div>
                                <!--Role Select-->
                                <div class="col-12">
                                    <div class="form-group">
                                        <ng-select2 [data]="rolesData" [options]="singleOption" ngModel id="role"
                                            name="role"
                                            [ngClass]="{ 'is-invalid': contactForm.submitted && role.invalid }" required
                                            #role="ngModel">

                                        </ng-select2>
                                        <!--                                        <select name="role"-->
                                        <!--                                                id="role"-->
                                        <!--                                                class="form-control"-->
                                        <!--                                                ngModel-->
                                        <!--                                                required-->
                                        <!--                                                [ngClass]="{ 'is-invalid': contactForm.submitted && role.invalid }"-->
                                        <!--                                                #role="ngModel"-->
                                        <!--                                        >-->
                                        <!--                                            <option value="" selected disabled hidden> &#45;&#45; Selecteaza optiune &#45;&#45;</option>-->
                                        <!--                                            <option value="Candidat">Candidat</option>-->
                                        <!--                                            <option value="Companie">Companie</option>-->
                                        <!--                                            <option value="Altele">Altele</option>-->
                                        <!--                                        </select>-->
                                        <!--Error Message-->
                                        <div class="error-msg"
                                            *ngIf="!role.valid && (role.touched || contactForm.submitted)">
                                            {{'VALIDATION.REQUIRED' | translate}}
                                        </div>
                                    </div>
                                </div>

                                <!--Subject Input-->
                                <div class="col-12">
                                    <div class="form-group">
                                        <input type="text" class="form-control" name="subject" #subject='ngModel'
                                            id="subject" required
                                            [ngClass]="{ 'is-invalid': contactForm.submitted && subject.invalid }"
                                            ngModel placeholder="{{'AGRI_CONTACT.SUBJECT' | translate}}">
                                        <!--Error Message-->
                                        <div class="error-msg"
                                            *ngIf="!subject.valid && (subject.touched || contactForm.submitted)">
                                            {{'VALIDATION.REQUIRED' | translate}}
                                        </div>
                                    </div>

                                </div>

                                <!--Message Input-->
                                <div class="col-12">
                                    <div class="form-group">
                                        <textarea name="message" class="form-control" id="message" cols="30" rows="8"
                                            required placeholder="{{'AGRI_CONTACT.MESSAGE' | translate}}"
                                            [ngClass]="{ 'is-invalid': contactForm.submitted && message.invalid }"
                                            ngModel #message="ngModel">

                                    </textarea>
                                        <!--Error Message-->
                                        <div class="error-msg"
                                            *ngIf="!message.valid && (message.touched || contactForm.submitted)">
                                            {{'VALIDATION.REQUIRED' | translate}}
                                        </div>
                                    </div>
                                </div>


                                <div class="col-12">
                                    <app-form-message [success]="formResponse" *ngIf="formSent"></app-form-message>
                                </div>


                                <!--Submit Button-->
                                <div class="col-12">
                                    <div class="text-center">
                                        <button type="submit" class="btn contact-btn">
                                            {{'BUTTONS.SEND' | translate}}
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </form> <!--Form End-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Footer-->
<app-footer></app-footer>